import { FC } from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { checkIsActive, KTIcon, WithChildren } from '../../../../helpers'
import { useLayout } from '../../../core'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  disabled?: boolean
  hasBullet?: boolean
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  disabled = false,
  fontIcon,
  hasBullet = false,
}) => {
  const { pathname } = useLocation()
  const isActive = checkIsActive(pathname, to)
  const { config } = useLayout()
  const { app } = config


  return (
    <div className={`position-relative menu-item ${disabled ? 'pe-none  cursor-not-allowed' : ''}`} style={{
      cursor: disabled ? 'not-allowed' : 'pointer',
    }}>

      <Link className={clsx('menu-link without-sub', { active: isActive })} to={to}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon'>
            <KTIcon iconName={icon} className='fs-2' />
          </span>
        )}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
          <i className={clsx('bi fs-3', fontIcon)}></i>
        )}
        <span className='menu-title position-relative'>
          <label className='menu-label'>{title} </label>
          {disabled && (
            <span
              className='badge bg-danger text-white position-absolute top-0 right-0   p-1 small'
              style={{ fontSize: '0.75rem', borderRadius: '0.25rem',right: '0.5rem', top: '0.5rem' }}
            >
              Soon
            </span>
          )}

        </span>
      </Link>
      {children}
    </div>
  )

}

export { SidebarMenuItem }
